import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { StatusCodes } from 'http-status-codes';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { StockTransactionAddDto } from '../../../../types/StockTransactionAddDto';
import { InventoryFormikValuesDto } from '../../../../types/InventoryFormikValuesDto';
import { quantityGetDtoToFormik } from '../../../../types/convertors/quantityGetDtoToFormik';
import { formikToTransactionAddDto } from '../../../../types/convertors/formikToTransactionAddDto';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import InventoryApi from '../../../../services/api/InventoryApi';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import GenericProductsApi from '../../../../services/api/GenericProductsApi';
import InventoryAddEditForm from '../components/InventoryAddEditForm';
import { fullSchema } from '../InventorySchema';

interface ParamProps {
  genericId: string;
}

export default function InventoryAddFromTemplate(): JSX.Element {
  const { genericId } = useParams<ParamProps>();
  const history = useHistory();
  const location = useLocation();
  const { item } = location?.state ?? {};
  const [generic, setGeneric] = useState('');

  const saveItem = async (
    values: InventoryFormikValuesDto,
    setSubmitting: (isSubmitting: boolean) => void,
  ): Promise<void> => {
    setSubmitting(true);
    const dto: StockTransactionAddDto = formikToTransactionAddDto(values, genericId);
    const result = await InventoryApi.add(dto);

    if (result.status === StatusCodes.OK) {
      history.push(`/inventory/list-for-generic/in-warehouse/${dto.warehouseId}/${genericId}`);
    } else {
      setSubmitting(false);
    }
  };

  const getGenericItem = async (): Promise<void> => {
    const result = await GenericProductsApi.get(genericId);
    setGeneric(result.data);
  };

  const initialValues = quantityGetDtoToFormik(item, true);
  const formik = useFormik({
    initialValues,
    validationSchema: fullSchema,
    onSubmit: async (values, { setSubmitting }) => {
      return saveItem(values, setSubmitting);
    },
  });

  useEffect(() => {
    if (genericId) {
      getGenericItem();
    }
  }, []);

  return (
    <WhitePad isFluid>
      <TitleComponent
        onLeftHandler={(): void => {
          history.push(`/inventory/list-for-generic/${genericId}`);
        }}
        title="Create Warehouse Stock"
      />
      {generic && <InventoryAddEditForm formikProps={formik} generic={generic} />}
    </WhitePad>
  );
}
